import { ChangeDetectorRef, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, Validators } from "@angular/forms";
import { AddOpportunityService } from "@app/features/customers/add-opportunity/service/add-opportunity.service";
import * as moment from "moment";
import { Subject } from 'rxjs';
import { SharedModalService } from '../service/shared-modal.service';
import { switchMap } from 'rxjs/operators';
import { PropertyViewService } from '@app/features/customers/customer/property-view/service/property-view.service';
import { Observable } from 'rxjs';
import { CsToastBoxService } from '@app/services';
import { AuthService, SettingsService } from "@app/core";
import { CsActivityLogEventService } from "@app/shared/cs-activity-log/cs-activity-log-event.service";
import { ActivityAddTagComponent } from "@app/shared/activity-add-tag/activity-add-tag.component";
var ScheduledActivityModalComponent = /** @class */ (function () {
    function ScheduledActivityModalComponent(sharedModalService, fb, opportunityService, confirmationBoxHelper, propertyService, toast, ajsScope, settingsService, _alEvent, authService, cdr) {
        this.sharedModalService = sharedModalService;
        this.fb = fb;
        this.opportunityService = opportunityService;
        this.confirmationBoxHelper = confirmationBoxHelper;
        this.propertyService = propertyService;
        this.toast = toast;
        this.ajsScope = ajsScope;
        this.settingsService = settingsService;
        this._alEvent = _alEvent;
        this.authService = authService;
        this.cdr = cdr;
        this.selectedActivityType = 1;
        this.selectedDate = 'Today';
        this.customDate = [];
        this.select2Config = { width: '100%', dropdownCssClass: 'scheduled-activity-add-tag' };
        //   assigneeList: any = [];
        //   scheduledData: any;
        this.deleted_array = [];
        this.subscriptions = {};
        this.completed = true;
        this.dateValuesChanged = false;
        this.scheduleButtonDisabled = false;
        this.minDate = new Date();
        this.editDateTime = '';
        this.showActivityModal = false;
        this.onSave = new EventEmitter();
        this.onClose = new EventEmitter();
        this.isCommonRoute = false;
        this.isCallFromCsActivityLog = false; // Note: This is used for modification according to `cs-activity-log.component`
        this.timepickerChangeEvent = new Subject();
        this.recordBasedAssigneeList = [];
        /** Recomputed per-open in openActivityModal() (recordType-based restriction on the edit path); applied when building select2AssigneeConfig. */
        this.assigneeListFilterFn = function (list) { return list || []; };
        /** Rebuilt each time select2AssigneeConfiguration runs, so the (long-lived) select2 widget always resolves against current data. */
        this.assigneeById = new Map();
        this.showTemplateList = false;
        this.screenLabel = 'Call note template';
        this.showAddNewTemplate = false;
        this.selectedCallNoteTemplate = null;
        this.IssetTemplateData = false;
        this.tagsList = [];
        this.selectedTags = [];
        this.removed_tag = [];
        this.showMeridian = true;
        this.select2AssigneeConfig = {};
        this.selectedTagLists = [];
    }
    ScheduledActivityModalComponent.prototype.trackByAssigneeId = function (index, assignee) {
        return assignee.id;
    };
    ScheduledActivityModalComponent.prototype.ngOnInit = function () {
        var _this = this;
        var intlSettings = this.settingsService.getIntlSettings();
        this.showMeridian = parseInt(intlSettings['time']) === 0;
        this.sharedModalService.getHashTagsList().subscribe(function (response) {
            _this.tagsList = response.hashtags;
        });
        this.initCalender();
        this.sharedModalService.scheduledActivityDetails$.subscribe(function (activityData) {
            if (activityData) {
                _this.sharedModalService.updateModalStatus('others', 'activity', activityData.showActivityModal);
                if (activityData.showActivityModal == false) {
                    _this.closeModalWithoutConfirmation();
                }
                else {
                    $(".modal-dialog").removeClass("modal-dialog-open");
                }
                _this.isCommonRoute = activityData.isCommonRoute || false;
                _this.showActivityModal = activityData.showActivityModal || '';
                _this.listActivity = activityData.listActivity || '';
                _this.assigneeList = activityData.assigneeList || '';
                _this.scheduledData = activityData.scheduledData || null;
                _this.screenType = activityData.screenType || '';
                _this.tablePkId = activityData.tablePkId || '';
                _this.opportunityId = activityData.opportunityId || '';
                _this.isCallFromCsActivityLog = activityData['isCallFromCsActivityLog'] || false;
                _this.IssetTemplateData = activityData['scheduledData'] === null;
                _this.selectedCallNoteTemplate = null;
                if (activityData['scheduledData']) {
                    _this.selectedCallNoteTemplate = activityData['scheduledData']['template'];
                    if (_this.selectedCallNoteTemplate) {
                        _this.selectedCallNoteTemplate.templateName = activityData['scheduledData']['template']['name'];
                        _this.selectedCallNoteTemplate.templateId = activityData['scheduledData']['templateId'];
                    }
                    if (_this.scheduledData.savedTags) {
                        _this.selectedTags = _this.scheduledData.savedTags.length > 0 ? _this.scheduledData.savedTags.map(function (t) { return t.id.toString(); }) : [];
                        _this.selectedTagLists = _this.scheduledData.savedTags.length > 0 ? _this.scheduledData.savedTags : [];
                    }
                }
                _this.afterSave = activityData['afterSave'] || null;
                _this.openActivityModal();
            }
            _this.select2AssigneeConfiguration(activityData.assigneeList);
        });
    };
    ScheduledActivityModalComponent.prototype.openModal = function () {
        var _this = this;
        setTimeout(function () {
            if ($.fn.modal && $.fn.modal.Constructor) {
                $.fn.modal.Constructor.prototype.enforceFocus = function () { };
            }
            var modalInstance = $('#modalPopUp').data('bs.modal');
            if (modalInstance) {
                modalInstance._config.focus = false;
            }
            $('#modalPopUp').modal({ backdrop: false, keyboard: false, focus: false });
            $(".modal-header").css("background", "#5E7F7D");
            $('.activityModal__').modal('show');
            $(".modal-dialog").addClass("modal-dialog-open");
            var el = document.querySelector('.schedule-activity-description');
            if (el) {
                el.focus();
            }
            var assignToElement = document.querySelector('#s2id_assignTo');
            if (assignToElement) {
                assignToElement.addEventListener('click', function () {
                    assignToElement.style.borderBottom = '1px solid var(--Base-structure-Stroke, #E1E1E1)';
                    _this.updateDropdownPosition(assignToElement, 'scheduled-activity-assignee-dropdown', 118);
                });
                var assignToInput = assignToElement.querySelector('.select2-search-field input');
                if (assignToInput) {
                    assignToInput.addEventListener('input', function () {
                        _this.updateDropdownPosition(assignToElement, 'scheduled-activity-assignee-dropdown', 118);
                    });
                    assignToInput.addEventListener('keyup', function () {
                        _this.updateDropdownPosition(assignToElement, 'scheduled-activity-assignee-dropdown', 118);
                    });
                }
            }
        }, 500);
    };
    ScheduledActivityModalComponent.prototype.openActivityModal = function () {
        var _this = this;
        // Assign field starts empty; matching users are shown only once the user types
        // (see select2AssigneeConfiguration's `query`), so this never renders the full list.
        this.recordBasedAssigneeList = [];
        this.assigneeListFilterFn = function (list) { return list || []; };
        if (this.showActivityModal) {
            this.countryDetails = this.settingsService.getCountryCode();
            if (!this.scheduledData || this.scheduledData == 'reschedule') {
                this.buildForm();
                this.openModal();
            }
            else {
                if (this.scheduledData.checked) {
                    if (this.scheduledData.activityCompleted) {
                        this.completed = false;
                    }
                    else {
                        this.completed = true;
                    }
                }
                if (this.scheduledData.isScheduled) {
                    var selectedActivity = null;
                    this.buildForm();
                    this.openModal();
                    if (this.listActivity) {
                        selectedActivity = this.listActivity.find(function (item) { return item.name == _this.scheduledData.activityType; });
                        this.selectedActivityType = selectedActivity.id;
                    }
                    if (selectedActivity) {
                        this.scheduleForm.controls['activityType'].setValue(selectedActivity.id);
                    }
                    this.scheduleForm.controls['description'].setValue(this.scheduledData.description);
                    this.scheduleForm.controls['notes'].setValue(this.scheduledData.notes);
                    if (this.scheduledData.recordType == 'Opportunities') {
                        this.assigneeListFilterFn = function (list) { return (list || []).filter(function (item) { return item.salesroleid !== '8' && item.salesroleid !== null; }); };
                    }
                    else {
                        //sales dispatcher license role is 8, we are restricting lite user to assign scheduled activity
                        this.assigneeListFilterFn = function (list) { return (list || []).filter(function (item) { return !(item.salesroleid === '8' && item.jmsroleid === null); }); };
                    }
                    if ((this.scheduledData.assignees || []).length != 0) {
                        var assignedUserId_1 = [];
                        for (var i = 0; i < this.scheduledData.assignees.length; i++) {
                            assignedUserId_1.push(this.scheduledData.assignees[i].id);
                        }
                        this.scheduleForm.controls['assigneeIds'].setValue(assignedUserId_1);
                        // The assignee field's select2 widget is only ever initialized once and reused
                        // across opens (see openModal()), so re-selecting programmatically here is what
                        // actually refreshes the visible chips — setValue() above alone doesn't reach it.
                        setTimeout(function () {
                            $('#assignTo').select2('val', assignedUserId_1);
                        }, 500);
                    }
                    if ((this.scheduledData.savedTags || []).length != 0) {
                        var assignedTagId_1 = [];
                        for (var i = 0; i < this.scheduledData.savedTags.length; i++) {
                            assignedTagId_1.push(this.scheduledData.savedTags[i].id);
                        }
                        setTimeout(function () {
                            var tagSet = [];
                            $('#tagTo').find('option').each(function (key, val) {
                                var tagData = $(val).val();
                                var tagArray = tagData.split(': ').pop();
                                var checkKey = assignedTagId_1.includes(parseInt(tagArray, 10));
                                if (checkKey) {
                                    tagSet.push(tagData);
                                }
                            });
                            $('#tagTo').val(tagSet).trigger('change');
                        }, 500);
                    }
                    var dateToShow = this.scheduledData.dateToShow['date'] ? this.scheduledData.dateToShow['date'] : this.scheduledData.dateToShow;
                    var date = new Date(dateToShow);
                    var scheduledDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
                    this.activityDateEdit = scheduledDate;
                    if (this.activityDateEdit) {
                        $('#scheduledDate').addClass('input-width');
                        $('#scheduledDate').removeClass('input-date-width');
                        $('#scheduledDate').removeClass('date-width');
                    }
                    if (this.countryDetails['code'] == 44) {
                        this.selectedDate = moment(dateToShow).format('DD/MM/YYYY');
                    }
                    else if (this.countryDetails['code'] == 1) {
                        this.selectedDate = moment(dateToShow).format('MM/DD/YYYY');
                    }
                    this.scheduleEditDate = this.selectedDate;
                    this.scheduleForm.controls['scheduledDate'].setValue(this.selectedDate);
                    var editDate = new Date(moment(dateToShow).format('YYYY-MM-DD HH:mm:ss'));
                    this.scheduleForm.controls['scheduleTime'].setValue(editDate);
                    this.editDateTime = editDate;
                    this.scheduleForm.updateValueAndValidity();
                    $(".modal-header").css("background", "#5E7F7D");
                    $('.activityModal__').modal('show');
                    $(".modal-dialog").addClass("modal-dialog-open");
                }
                else {
                    this.closeModalWithoutConfirmation();
                }
            }
        }
        else {
            this.closeModalWithoutConfirmation(false);
        }
    };
    ScheduledActivityModalComponent.prototype.buildForm = function () {
        var _this = this;
        this.dateValuesChanged = true;
        this.scheduleForm = this.fb.group({
            'assigneeIds': [''],
            'notes': [''],
            'description': ['', Validators.required],
            'scheduledDate': [''],
            'scheduleTime': [''],
            'activityType': [1],
            'tagIds': ['']
        });
        this.scheduleForm.get('scheduledDate').setValue(this.selectedDate);
        this.selectedActivityType = 1;
        this.scheduleForm.get('activityType').setValue(this.selectedActivityType);
        var momentTime = moment();
        var reminder = 15 - (momentTime.minute() % 15);
        if (reminder == 15) {
            reminder = 0;
        }
        var roundTime = moment(momentTime).add(reminder, "minutes").format();
        var time = new Date(roundTime);
        this.scheduleForm.controls['scheduleTime'].setValue(time);
        this.scheduleForm.controls['scheduledDate']
            .valueChanges.subscribe(function (value) {
            if (_this.dateValuesChanged) {
                var momentCurrentTime = moment();
                var reminder_1 = 0;
                if (value == 'Today') {
                    reminder_1 = 15 - (momentCurrentTime.minute() % 15);
                    if (reminder_1 == 15) {
                        reminder_1 = 0;
                    }
                }
                else if (!_this.editDateTime) {
                    momentCurrentTime = moment().toDate();
                    momentCurrentTime.setHours(8);
                    momentCurrentTime.setMinutes(0);
                }
                else {
                    momentCurrentTime = _this.editDateTime;
                }
                var roundTime_1 = moment(momentCurrentTime).add(reminder_1, "minutes").format();
                var time_1 = new Date(roundTime_1);
                _this.scheduleForm.controls['scheduleTime'].setValue(time_1);
                _this.scheduleTime(time_1);
                _this.editDateTime = '';
                _this.cdr.detectChanges();
            }
        });
        // }
    };
    ScheduledActivityModalComponent.prototype.initCalender = function () {
        var date = Date.now();
        var momentBusinessDays = require("moment-business-days");
        var tomorrow = '(' + momentBusinessDays(date).businessAdd(2).format("dddd") + ')';
        var business2days = '(' + momentBusinessDays(date).businessAdd(3).format("dddd") + ')';
        var nextmonday = '(' + moment(date).add(1, 'week').day(1).format("MMMM DD") + ')';
        var oneweek = '(' + moment(date).add(7, 'days').format("MMMM DD") + ')';
        var twoweeks = '(' + moment(date).add(14, 'days').format("MMMM DD") + ')';
        var onemonth = '(' + moment(date).add(1, 'M').format("MMMM DD") + ')';
        var threemonths = '(' + moment(date).add(3, 'M').format("MMMM DD") + ')';
        var sixmonths = '(' + moment(date).add(6, 'M').format("MMMM DD") + ')';
        this.customDate = [{ 'id': 1, 'text': "Today", 'view_text': 'Today', 'name': '' },
            { 'id': 2, 'text': 'Tomorrow', 'view_text': 'Tomorrow', 'name': '' },
            { 'id': 3, 'text': 'in.business.days', 'text_days': '2', 'view_text': 'in.2.business.days', 'name': tomorrow },
            { 'id': 4, 'text': 'in.business.days', 'view_text': 'in.3.business.days', 'text_days': '3', 'name': business2days },
            { 'id': 5, 'text': 'next.monday', 'view_text': 'next.monday', 'text_days': 'Next', 'name': nextmonday },
            { 'id': 6, 'text': 'in.1.week', 'view_text': 'in.1.week', 'text_days': '1', 'name': oneweek },
            { 'id': 7, 'text': 'in.weeks', 'view_text': 'in.2.weeks', 'text_days': '2', 'name': twoweeks },
            { 'id': 8, 'text': 'in.1.month', 'view_text': 'in.1.month', 'text_days': '1', 'name': onemonth },
            { 'id': 9, 'text': 'in.months', 'view_text': 'in.3.months', 'text_days': '3', 'name': threemonths },
            { 'id': 10, 'text': 'in.months', 'view_text': 'in.6.months', 'text_days': '6', 'name': sixmonths },
            { 'id': 10, 'text': 'Custom date', 'view_text': 'Custom_date' }];
    };
    ScheduledActivityModalComponent.prototype.scheduleTime = function (time) {
        if (time instanceof Date && time.toString() != 'Invalid Date') {
            return this.scheduleForm.value.scheduleTime.toLocaleTimeString(['en-GB'], { timeStyle: 'short' });
        }
        else if (this.scheduledTime) {
            return this.scheduledTime;
        }
        else {
            return time;
        }
    };
    ScheduledActivityModalComponent.prototype.selectedType = function (type) {
        this.selectedActivityType = type.id;
        this.scheduleForm.controls['activityType'].setValue(type.id);
        this.selectedCallNoteTemplate = null;
    };
    ScheduledActivityModalComponent.prototype.closeModal = function (emitEvent) {
        var _this = this;
        if (emitEvent === void 0) { emitEvent = true; }
        // this.buildForm()
        if (this.useTemplate != undefined) {
            this.useTemplate.filterParams.search = '';
            this.useTemplate.filterParams.parentId = '';
            this.useTemplate.searchValue = '';
            this.useTemplate.selectedFolder = '';
            this.useTemplate.getTemplatesList();
        }
        $(".template-wrapper").removeClass("template-open");
        this.confirmationBoxHelper.getConfirmation('Are you sure you want to discard the schedule activity?', this.ajsScope)
            .then(function () {
            _this.closeModalWithoutConfirmation(emitEvent);
            _this.sharedModalService.updateModalStatus('others', 'activity', false);
            _this.selectedCallNoteTemplate = null;
        }).catch(function () { });
        this.selectedText = '';
    };
    ScheduledActivityModalComponent.prototype.closeModalWithoutConfirmation = function (emitEvent) {
        if (emitEvent === void 0) { emitEvent = true; }
        this.dateValuesChanged = false;
        this.assignee = undefined;
        $("#assignTo").val(null).trigger("change");
        $("#tagTo").val(null).trigger("change");
        if (this.scheduleForm) {
            this.scheduleForm.controls['assigneeIds'].setValue('');
            this.scheduleForm.controls['scheduledDate'].setValue('');
            this.scheduleForm.controls['scheduleTime'].setValue('');
            this.cdr.detectChanges();
            $('.activityModal__').modal('hide');
            $(".modal-dialog").removeClass("modal-dialog-open");
        }
        this.completed = false;
        this.editId = null;
        this.selectedTags = [];
        this.selectedTagLists = [];
        this.scheduledData = undefined;
        this.activityDateEdit = '';
        this.selectedDate = 'Today';
        this.sharedModalService.setCommonModalEmittedValue(false);
        if (emitEvent)
            this.onClose.emit(false);
        if (this.isCallFromCsActivityLog) {
            this._alEvent.resetActivityEventData();
        }
        if (this.tagDropdownComponent) {
            this.tagDropdownComponent.ngOnDestroy();
        }
    };
    ScheduledActivityModalComponent.prototype.getFilterByDate = function (id, text, name) {
        $('#dropdownd1').removeClass('dropdown');
        this.selectedId = id;
        if (this.selectedId == '1' || this.selectedId == '2') {
            $('#scheduledDate').addClass('input-width');
            $('#scheduledDate').removeClass('input-date-width');
            $('#scheduledDate').removeClass('date-width');
            this.selectedDate = text;
            this.selectedText = text;
            $('#caret-up').addClass('up-caret-icon');
        }
        else {
            var inputText = text.charAt(0).toUpperCase() + text.slice(1);
            this.selectedText = inputText.split('.').join('');
            this.selectedDate = inputText.split('.').join(' ') + " " + name;
            if (this.selectedId == '3' || this.selectedId == '4') {
                $('#caret-up').addClass('up-caret-icon');
                $('#caret-up').removeClass('dropdown-list-caret-icon');
            }
            else {
                $('#scheduledDate').addClass('input-date-width');
                $('#scheduledDate').removeClass('date-width');
                $('#scheduledDate').removeClass('input-width');
            }
        }
    };
    ScheduledActivityModalComponent.prototype.selectedCustom = function () {
        $('#dropdownd1').addClass('dropdown');
    };
    ScheduledActivityModalComponent.prototype.dateCreated = function ($event) {
        this.selectedDate = 'Custom date';
        this.selectedText = 'CustomDate';
        $('#caret-up').addClass('up-caret-icon');
        this.selectedCustomDate = $event;
    };
    ScheduledActivityModalComponent.prototype.getAssignee = function (data) {
        if (data) {
            this.assignee = Array.isArray(data) ? data : [data];
        }
    };
    ScheduledActivityModalComponent.prototype.getTags = function (data) {
        if (data) {
            var tagArray = [];
            for (var i = 0; i < data.length; i++) {
                tagArray.push(data[i].split(':')[1].trim().replace(/['"]+/g, ''));
            }
            this.selectedTags = tagArray;
        }
    };
    ScheduledActivityModalComponent.prototype.scheduledActivity = function () {
        var _this = this;
        $(".template-wrapper").removeClass("template-open");
        var scheduledData;
        this.dateValuesChanged = false;
        this.scheduleButtonDisabled = true;
        if (this.selectedText == 'CustomDate') {
            this.scheduleForm.value['scheduledDate'] = this.selectedCustomDate;
        }
        else {
            this.dateConversion(this.selectedText);
            this.selectedText = '';
        }
        if (this.scheduleForm.value['scheduledDate']) {
            var date = this.scheduleForm.value['scheduledDate'].toLocaleDateString('en-GB');
            this.scheduleForm.controls['scheduledDate'].setValue(date.replaceAll("/", "/"));
        }
        if (this.scheduleForm.value['scheduleTime']) {
            var time = this.scheduleForm.value['scheduleTime'].toLocaleTimeString('en-GB');
            var arr = time.split(':').slice(0, -1).join(":");
            time = arr + "";
            this.scheduledTime = time;
            this.scheduleForm.controls['scheduleTime'].setValue(time);
        }
        else {
            this.scheduleForm.controls['scheduleTime'].setValue("00:00:00");
        }
        this.deleted_array = [];
        var url;
        this.scheduledData = this.scheduledData ? this.scheduledData : null;
        if (this.scheduledData != null && this.scheduledData != 'reschedule') {
            if (this.scheduledData.hasOwnProperty('isScheduled')) {
                if ((this.scheduledData.assignees || []).length != 0) {
                    var selectedAsignees_1 = [];
                    for (var i = 0; i < this.scheduledData.assignees.length; i++) {
                        selectedAsignees_1.push(this.scheduledData.assignees[i]['id']);
                    }
                    var new_array = void 0;
                    if (this.assignee && selectedAsignees_1) {
                        var assignee_1 = this.assignee.map(Number);
                        new_array = assignee_1.filter(function (f) { return !selectedAsignees_1.includes(f); });
                        this.deleted_array = selectedAsignees_1.filter(function (f) { return !assignee_1.includes(f); });
                    }
                    if (new_array) {
                        this.scheduleForm.controls['assigneeIds'].setValue(new_array);
                    }
                    else {
                        this.scheduleForm.controls['assigneeIds'].setValue([]);
                    }
                }
                else {
                    this.scheduleForm.controls['assigneeIds'].setValue(this.assignee);
                }
                if ((this.scheduledData.savedTags || []).length != 0) {
                    // let selectedtags = [];
                    // for (var i = 0; i < this.scheduledData.savedTags.length; i++) {
                    //     selectedtags.push(this.scheduledData.savedTags[i]['id']);
                    // }
                    //
                    // let selectedValues = $('#tagTo').val();
                    // let resultArray = [];
                    // if(selectedValues != null){
                    //     resultArray = selectedValues.map(item => item.split(': ').pop());
                    // }
                    this.scheduleForm.controls['tagIds'].setValue(this.selectedTags);
                }
                else {
                    this.scheduleForm.controls['tagIds'].setValue(this.selectedTags);
                }
                scheduledData = this.scheduleForm.value;
                if (this.deleted_array) {
                    scheduledData.deletedAssigneeIds = this.deleted_array;
                }
                else {
                    scheduledData.deletedAssigneeIds = [];
                }
                url = "sales/editScheduleActivity/" + this.scheduledData.activityId;
            }
        }
        else {
            this.scheduleForm.controls['assigneeIds'].setValue(this.assignee);
            this.scheduleForm.controls['tagIds'].setValue(this.selectedTags);
            scheduledData = this.scheduleForm.value;
            url = "sales/scheduleOpportunityActivity/" + this.opportunityId;
        }
        var logId = null;
        if (this.scheduledData) {
            logId = this.scheduledData.logId;
        }
        scheduledData = this.scheduleForm.value;
        // Date format change
        var scheduledDate = moment(scheduledData['scheduledDate'], "DD-MM-YYYY").format("MM-DD-YYYY");
        scheduledDate = scheduledDate + " " + scheduledData['scheduleTime'];
        var new_date = new Date(scheduledDate);
        scheduledData['scheduled_date'] = new_date;
        scheduledData['callNoteTemplateId'] = this.selectedCallNoteTemplate && +(this.selectedCallNoteTemplate.templateId) || null;
        if (this.isCommonRoute) {
            this.scheduleButtonDisabled = false;
            if (this.scheduledData != null && this.scheduledData != 'reschedule') {
                scheduledData.scheduleId = this.scheduledData.activityId;
            }
            scheduledData.logId = logId;
            scheduledData.screenType = this.screenType;
            scheduledData.tablePkId = this.tablePkId;
            this.onActivityScheduleSave(scheduledData);
        }
        else {
            this.opportunityService.createScheduledActivity(scheduledData, url).subscribe(function (res) {
                _this.onSave.emit(_this.scheduledData);
                _this.scheduleButtonDisabled = false;
                if (_this.scheduledData) {
                    if (_this.scheduledData != null && _this.scheduledData.hasOwnProperty('runThroughActivity')) {
                        _this.sharedModalService.refreshCompleteActivity('reschedule');
                    }
                    else if (_this.scheduledData.hasOwnProperty('edit')) {
                        _this.sharedModalService.refreshCompleteActivity('update');
                    }
                }
                _this.closeModalWithoutConfirmation();
                _this.sharedModalService.setStatusUpdated('true');
            }, function (error1) {
                console.log(error1);
            });
            this.sharedModalService.updateModalStatus('others', 'activity', false);
        }
        this.selectedText = '';
        // this.selectedCallNoteTemplate = null;
    };
    ScheduledActivityModalComponent.prototype.onActivityScheduleSave = function (data) {
        var _this = this;
        var saveObservable = data.hasOwnProperty('scheduleId') ?
            this.propertyService.saveEditScheduledActivity(data, data['scheduleId']) :
            this.propertyService.saveScheduledActivity(data);
        this.propertyService.timelineRefresh$.subscribe(function (refreshData) {
            _this.newRefreshData = refreshData;
        });
        saveObservable.pipe(switchMap(function (savedData) {
            var scheduledSnapshot = _this.scheduledData;
            var shouldRefreshRunThroughReschedule = scheduledSnapshot != null && scheduledSnapshot.hasOwnProperty('runThroughActivity');
            var shouldRefreshRunThroughUpdate = scheduledSnapshot != null && scheduledSnapshot.hasOwnProperty('edit');
            var refreshData = {
                fromDate: "",
                isSearch: false,
                object: "",
                page: 1,
                search: "",
                toDate: "",
                userId: "",
                screen: _this.screenType,
            };
            refreshData['data'] = {
                screen: data.hasOwnProperty('logId') && data.logId ? 'editActivity' : 'addScheduleActivity',
                type: data.hasOwnProperty('scheduleId') ? 'update' : 'add',
                values: null,
                id: data.hasOwnProperty('logId') && data.logId ? data.logId : 'latest'
            };
            if (_this.isCallFromCsActivityLog) {
                if (_this.afterSave)
                    _this.afterSave(data);
            }
            else {
                // this.propertyService.setRefreshSliderScheduleActivity(true);
                if (_this.screenType == 'jobs' || _this.screenType == 'jobs_tab') {
                    _this.propertyService.setTimelineRefresh(_this.newRefreshData);
                }
                else {
                    _this.propertyService.setTimelineRefresh(refreshData);
                }
            }
            if (shouldRefreshRunThroughReschedule) {
                _this.sharedModalService.refreshCompleteActivity('reschedule');
            }
            else if (shouldRefreshRunThroughUpdate) {
                _this.sharedModalService.refreshCompleteActivity('update');
            }
            _this.sharedModalService.updateModalStatus('others', 'activity', false);
            _this.showToast(data.hasOwnProperty('scheduleId') ? 'Scheduled activity updated' : 'Scheduled activity added');
            // Return an observable to satisfy switchMap
            return new Observable(function (observer) {
                observer.next();
                observer.complete();
            });
        })).subscribe(function (res) {
            _this.closeModalWithoutConfirmation();
        });
        this.sharedModalService.setStatusUpdated('true');
    };
    ScheduledActivityModalComponent.prototype.showToast = function (msg) {
        this.toast.show(msg, 1500);
    };
    ScheduledActivityModalComponent.prototype.dateConversion = function (data) {
        var momentBusinessDays = require("moment-business-days");
        var today = new Date();
        if (data == 'Today') {
            var date = moment(today);
            this.scheduleForm.value['scheduledDate'] = date['_d'];
        }
        else if (data == 'Tomorrow') {
            var date = moment(today).add(1, 'days');
            this.scheduleForm.value['scheduledDate'] = date['_d'];
        }
        else if (data == 'In2businessdays') {
            var date = momentBusinessDays(today).businessAdd(2, 'days');
            this.scheduleForm.value['scheduledDate'] = date['_d'];
        }
        else if (data == 'In3businessdays') {
            var date = momentBusinessDays(today).businessAdd(3, 'days');
            this.scheduleForm.value['scheduledDate'] = date['_d'];
        }
        else if (data == 'Nextmonday') {
            var date = moment(today).add(1, 'week').day(1);
            this.scheduleForm.value['scheduledDate'] = date['_d'];
        }
        else if (data == 'In1week') {
            var date = moment(today).add(7, 'days');
            this.scheduleForm.value['scheduledDate'] = date['_d'];
        }
        else if (data == 'In2weeks') {
            var date = moment(today).add(14, 'days');
            this.scheduleForm.value['scheduledDate'] = date['_d'];
        }
        else if (data == 'In1month') {
            var date = moment(today).add(1, 'M');
            this.scheduleForm.value['scheduledDate'] = date['_d'];
        }
        else if (data == 'In3months') {
            var date = moment(today).add(3, 'M');
            this.scheduleForm.value['scheduledDate'] = date['_d'];
        }
        else if (data == 'In6months') {
            var date = moment(today).add(6, 'M');
            this.scheduleForm.value['scheduledDate'] = date['_d'];
        }
        else {
            if (this.selectedDate == 'Today') {
                var today_1 = new Date();
                var date = moment(today_1);
                this.scheduleForm.value['scheduledDate'] = date['_d'];
                $('#caret-up').addClass('up-caret-icon');
            }
            else {
                this.scheduleForm.value['scheduledDate'] = this.activityDateEdit;
            }
        }
    };
    ScheduledActivityModalComponent.prototype.omitSpecialChar = function (event) {
        var charCode = (event.which) ? event.which : event.keyCode;
        if ((charCode < 48 || charCode > 57)) {
            event.preventDefault();
            return false;
        }
        else {
            return true;
        }
    };
    ScheduledActivityModalComponent.prototype.timepickerIncrement = function (event) {
        if (event == 'time') {
            var element = $('.hour-min').first();
            var hour = element.find('option:selected');
            var newHour = '';
            if (!hour.next().length) {
                newHour = '00';
                element.find('option').first().prop('selected', 'selected');
            }
            else {
                newHour = hour.next().val();
                hour.next().prop('selected', 'selected');
            }
            var changeObject = { hour: newHour };
            this.timepickerChangeEvent.next(changeObject);
        }
        else if (event == 'min') {
            var element = $('.hour-min').last();
            var min = element.find('option:selected');
            var newMin = '';
            if (!min.next().length) {
                newMin = '00';
                element.find('option').first().prop('selected', 'selected');
            }
            else {
                newMin = min.next().val();
                min.next().prop('selected', 'selected');
            }
            var changeObject = { min: newMin };
            this.timepickerChangeEvent.next(changeObject);
        }
    };
    ScheduledActivityModalComponent.prototype.timepickerDecrement = function (event) {
        if (event == 'time') {
            var element = $('.hour-min').first();
            var hour = element.find('option:selected');
            var newHour = '';
            if (!hour.prev().length) {
                newHour = '23';
                element.find('option').first().prop('selected', 'selected');
            }
            else {
                newHour = hour.prev().val();
                hour.prev().prop('selected', 'selected');
            }
            var changeObject = { hour: newHour };
            this.timepickerChangeEvent.next(changeObject);
        }
        else if (event == 'min') {
            var element = $('.hour-min').last();
            var min = element.find('option:selected');
            var newMin = '';
            if (!min.prev().length) {
                newMin = '45';
                element.find('option').first().prop('selected', 'selected');
            }
            else {
                newMin = min.prev().val();
                min.prev().prop('selected', 'selected');
            }
            var changeObject = { min: newMin };
            this.timepickerChangeEvent.next(changeObject);
        }
    };
    ScheduledActivityModalComponent.prototype.showTemplateOptions = function () {
        $(".template-wrapper").addClass("template-open");
        this.showTemplateList = true;
        $("#emailcontent").addClass("overlay");
    };
    ScheduledActivityModalComponent.prototype.cancelTemplate = function () {
        $("#emailcontent").removeClass("overlay");
        $(".template-wrapper").removeClass("template-open");
        this.showTemplateList = false;
    };
    ScheduledActivityModalComponent.prototype.setTemplateDetails = function (selectedTemplate) {
        console.log('st', selectedTemplate);
        this.selectedCallNoteTemplate = selectedTemplate;
        $(".template-wrapper").removeClass("template-open");
        this.showTemplateList = false;
    };
    ScheduledActivityModalComponent.prototype.hasAmPm = function (value) {
        return /am|pm/i.test(value);
    };
    ScheduledActivityModalComponent.prototype.convertTo24Hour = function (timeString) {
        var _a = timeString.toLowerCase().split(" "), time = _a[0], modifier = _a[1];
        var _b = time.split(":").map(Number), hours = _b[0], minutes = _b[1];
        if (modifier === "pm" && hours !== 12) {
            hours += 12;
        }
        if (modifier === "am" && hours === 12) {
            hours = 0;
        }
        return hours.toString().padStart(2, "0") + ":" + minutes.toString().padStart(2, "0");
    };
    ScheduledActivityModalComponent.prototype.convertToDateObject = function (time24) {
        var _a = time24.split(":").map(Number), hours = _a[0], minutes = _a[1];
        var date = new Date();
        date.setHours(hours, minutes, 0, 0);
        return date;
    };
    ScheduledActivityModalComponent.prototype.timeChange = function (event) {
        var time24;
        if (this.hasAmPm(event)) {
            // Case: 10:30 am / 10:30 pm
            time24 = this.convertTo24Hour(event);
        }
        else {
            // Case: 10:30 or 22:30
            time24 = event;
        }
        var dateObj = this.convertToDateObject(time24);
        this.scheduleForm.patchValue({
            scheduleTime: dateObj
        });
        this.scheduleTime(dateObj);
    };
    ScheduledActivityModalComponent.prototype.select2AssigneeConfiguration = function (assigneeList) {
        var _this = this;
        this.recordBasedAssigneeList = this.assigneeListFilterFn(assigneeList || []);
        this.assigneeById = new Map(this.recordBasedAssigneeList.map(function (item) { return [String(item.id), item]; }));
        this.select2AssigneeConfig = {
            multiple: true,
            width: '240px',
            dropdownCssClass: "scheduled-activity-assignee-dropdown",
            minimumInputLength: 1,
            // Filters the already-loaded in-memory list — no options are rendered until the user types,
            // so opening/closing this field never triggers a large-DOM change detection pass.
            // Reads this.recordBasedAssigneeList/this.assigneeById (not a closure) since the select2
            // widget itself is only ever initialized once and reused across opens — see openModal().
            query: function (query) {
                var term = (query.term || '').toLowerCase();
                var results = _this.recordBasedAssigneeList.filter(function (a) { return (a.username || '').toLowerCase().includes(term); });
                query.callback({ results: results.map(function (a) { return ({ id: a.id, text: a.username }); }) });
            },
            initSelection: function (element, callback) {
                var rawIds = (_this.scheduleForm && _this.scheduleForm.controls['assigneeIds'] && _this.scheduleForm.controls['assigneeIds'].value) || [];
                var ids = Array.isArray(rawIds) ? rawIds : [rawIds];
                var data = ids
                    .map(function (id) { return _this.assigneeById.get(String(id)); })
                    .filter(Boolean)
                    .map(function (a) { return ({ id: a.id, text: a.username }); });
                callback(data);
            },
            formatResult: function (data) {
                var assignee = _this.assigneeById.get(String(data.id));
                var element;
                if (assignee && assignee.profilepicture) {
                    element = $('<span><img src="' + assignee.profilepicture + '" style="width: 24px;height: 24px;border-radius: 50%;" /> ' + data.text + '</span>');
                }
                else {
                    var initials = data.text.split(' ');
                    var firstInitial = initials[0] ? initials[0][0].toUpperCase() : '';
                    var secondInitial = initials[1] ? initials[1][0].toUpperCase() : '';
                    element = $('<span style="display: flex; align-items: center"><span style="width: 24px;height: 24px;border-radius: 50%;background: #F2994A; color: white; font-size: 10px; font-weight: 700; display: inline-flex; align-items: center; justify-content: center; margin-right: 6px">'
                        + firstInitial + secondInitial + '</span>' + data.text + '</span>');
                }
                return element;
            },
            formatSelection: function (data) {
                var assignee = _this.assigneeById.get(String(data.id));
                if (assignee && assignee.profilepicture) {
                    return "<div style=\"font-size: 12px; color: #505b65;\">\n                                <img src=\"" + assignee.profilepicture + "\" style=\"width: 14px; height: 14px; border-radius: 50%;\" />\n                                " + data.text + "\n                            </div>";
                }
                else {
                    var initials = data.text.split(' ');
                    var firstInitial = initials[0] ? initials[0][0].toUpperCase() : '';
                    var secondInitial = initials[1] ? initials[1][0].toUpperCase() : '';
                    return "<div style=\"display: flex; font-size: 12px; color: #505b65;\">\n                                <span style=\"width: 14px; height: 14px; border-radius: 50%; background: #F2994A; color: white; font-size: 8px; font-weight: 700; display: inline-flex; align-items: center; justify-content: center; margin-right: 4px;\">\n                                    " + firstInitial + secondInitial + "\n                                </span>\n                                " + data.text + "\n                            </div>";
                }
            }
        };
    };
    ScheduledActivityModalComponent.prototype.updateDropdownPosition = function (element, dropdownClass, offsetBottom) {
        if (element) {
            var searchInput = element.querySelector('.select2-search-field');
            if (searchInput) {
                var rect = searchInput.getBoundingClientRect();
                var dropdown = document.body.querySelector("." + dropdownClass);
                if (dropdown) {
                    dropdown.style.left = rect.left + 10 + "px";
                    dropdown.style.bottom = offsetBottom + "px";
                }
            }
        }
    };
    ScheduledActivityModalComponent.prototype.onTagSelected = function (tag) {
        this.selectedTags.push(tag.id.toString());
    };
    ScheduledActivityModalComponent.prototype.onTagRemoved = function (tag) {
        this.selectedTags = this.selectedTags.filter(function (t) { return t != tag.id.toString(); });
    };
    ScheduledActivityModalComponent.prototype.showScheduleTime = function (time) {
        if (time instanceof Date && time.toString() != 'Invalid Date') {
            var hours = time.getHours();
            var minutes = time.getMinutes();
            var paddedHours = hours.toString().padStart(2, '0');
            var paddedMinutes = minutes.toString().padStart(2, '0');
            if (this.showMeridian) {
                // Format as 12-hour with AM/PM
                var hour12 = hours % 12;
                if (hour12 === 0) {
                    hour12 = 12;
                }
                var meridian = hours >= 12 ? 'PM' : 'AM';
                return hour12.toString().padStart(2, '0') + ":" + paddedMinutes + " " + meridian;
            }
            else {
                // Format as 24-hour
                return paddedHours + ":" + paddedMinutes;
            }
        }
        else if (this.scheduledTime) {
            return this.scheduledTime;
        }
        else {
            return time;
        }
    };
    return ScheduledActivityModalComponent;
}());
export { ScheduledActivityModalComponent };
